import workspaceQuery from '../../queries/common/ReferenceAllocationFailureWorkspaceQuery.graphql';
import instanceQuery from '../../queries/common/ReferenceAllocationFailureQuery.graphql';
import fragment from '../../fragments/common/ReferenceAllocationFailureFragment.graphql';
import mutationQuery from '../../mutations/common/ReferenceAllocationFailureMutation.graphql';
import { EntityType } from '../../../@types/entityTypes';

const ReferenceAllocationFailure: EntityType = {
  type: 'ReferenceAllocationFailure',
  title: 'Reference Continuity',
  workspaceUrl: '/Common/ReferenceAllocation/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  update: mutationQuery,
  fragment,

  // We only want admin users to be able to see this Workspace for the moment - The most trivial way to achieve this is tagging it with a SYSTEM screenReference.
  screenReference: 'SYSTEM',
};

export default ReferenceAllocationFailure;
